export default __webpack_public_path__ + "static/media/try-atomic-home.f6133c56.png";